import { IComplaint } from '../../api/complaint';
import { TAddComplaintActions } from './add_complaint';
import { TGetComplaintsActions } from './get_complaints';

export interface IComplaintState {
  complaints: IComplaint[] | null;
  errorMessage: string | null;
  isComplaintAdded: boolean;
  isLoading: boolean;
  getUserFeedback: boolean;
}

const defaultState: IComplaintState = {
  complaints: null,
  errorMessage: null,
  isComplaintAdded: false,
  isLoading: false,
  getUserFeedback: false,
};

export interface IComplaintStateReseted {
  type: 'IComplaintStateReseted';
}
/* istanbul ignore next */
export function resetComplaintState(): IComplaintStateReseted {
  return {
    type: 'IComplaintStateReseted',
  };
}
/* istanbul ignore next */
export function complaintReducer(
  state: IComplaintState,
  action: IComplaintStateReseted | TGetComplaintsActions | TAddComplaintActions,
): IComplaintState {
  switch (action.type) {
    case 'IComplaintStateReseted':
      return {
        ...state,
        errorMessage: null,
        isComplaintAdded: false,
        isLoading: false,
      };

    case 'IComplaintsRequested':
    case 'IAddComplaintRequested':
      return {
        ...state,
        isLoading: true,
      };

      case 'IComplaintsReceived':
        return {
          ...state,
          complaints: action.complaints,
          isLoading: false,
        };

      case 'IAddComplaintRequestFinished':
        return {
          ...state,
          isComplaintAdded: true,
          isLoading: false,
          getUserFeedback: action.getUserFeedback,
        };

      case 'IComplaintsFailed':
      case 'IAddComplaintRequestFailed':
        return {
          ...state,
          errorMessage: action.errorMessage,
          isLoading: false,
        };

    default:
      return state || defaultState;
  }
}
